import React from 'react';
import ScreenContainer from '../common/layout/ScreenContainer';
import { RecentProjects } from './RecentProjects';
import { useSelector } from 'react-redux';
import { RootState } from '../../data/store';
import { HeaderTitle } from '../common/layout/PageHeader';
import QuickLinks from './QuickLinks';
import KeyLinks from './KeyLinks';
import { Grid, Box, useTheme, useMediaQuery } from '@mui/material';

export default function HomeDashboardScreen() {
	const { user } = useSelector((state: RootState) => state.authState);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<ScreenContainer
			style={{ padding: isMobile ? '0px' : '2px', overflow: 'auto' }}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: 2,
					padding: isMobile ? '10px' : '0px',
				}}
			>
				<HeaderTitle
					sx={{
						fontSize: isMobile ? '1.5rem' : '2rem',
						textAlign: isMobile ? 'center' : 'left',
					}}
				>
					Welcome, {user?.firstName} {user?.lastName}
				</HeaderTitle>
				<Grid container spacing={isMobile ? 1 : 2}>
					<Grid item xs={12} md={12}>
						<QuickLinks />
					</Grid>
					<Grid item xs={12}>
						<RecentProjects />
					</Grid>
				</Grid>
			</Box>
		</ScreenContainer>
	);
}
